<!--
 * @Author: 谢树和 shuhe.xie@southgis.com
 * @Date: 2022-09-22 11:23:31
 * @LastEditors: 谢树和 shuhe.xie@southgis.com
 * @LastEditTime: 2022-10-18 09:51:14
 * @FilePath: \standard-v5\src\views\Information\WorkGuideHome.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<script>
import CommonHome from '@/views/Information/CommonHome'
import api from '@/utils/api/operation'
export default {
  name: 'WorkGuideHome',
  extends: CommonHome,
  data() {
    return {
      searchValue: ''
    }
  },
  computed: {
    navTitle() {
      return '办事指南'
    }
  },
  methods: {
    loadData(data) {
      let params = {
        page: data.page,
        rows: data.rows,
        BT: this.searchValue
      }
      return api.getWorkGuideList(params).then(res => {
        this.list = res.data.rowsList
        return Promise.resolve(res)
      })
    },
    itemClicked(item) {
      this.$router.push({
        name: 'WorkGuideDetail',
        query: {
          rid: item.RID
        }
      })
    }
  }
}
</script>
